import type { BubbleMounter } from '../types'
import { isDOM } from '@app/shared/predicates'

import buildMounter from '@app/application/communication/handlers/live-input-bubble-mounter'

export default (): void => {
  let mounter: BubbleMounter

  window.onDomLoad(function ($dom) {
    const doc = $dom[0]

    const mounterTarget = getMounterTarget(doc)

    if (mounterTarget) {
      mounter = buildMounter(isPreviewMode(doc))

      mounter.mount({ container: mounterTarget })
    }

    if (isDOM(doc) && mounter) {
      doc.addEventListener(
        'turbolinks:visit',
        function () {
          mounter.teardown()
        },
        { once: true }
      )
    }
  })
}

const getMounterTarget = (target: Document | Element): HTMLElement | null => {
  if (!target) {
    return null
  }

  if (isDOM(target)) {
    const shouldAttach = target.querySelector(
      "[data-link-inputs-to-remarks='true']"
    )

    // limit bubbles lookup/insertion only in the current reconciliation, not the comparative reconciliation
    const bubblesContainer = target.querySelector(
      '#reconciliation-table-bloc'
    ) as HTMLElement

    return shouldAttach ? bubblesContainer : null
  } else {
    const effectiveTarget = target as HTMLElement

    const shouldAttach = effectiveTarget.dataset.linkInputsToRemarks === 'true'

    return shouldAttach ? effectiveTarget : null
  }
}

const isPreviewMode = (target: Document | Element): boolean => {
  if (!target) {
    return false
  }

  if (isDOM(target)) {
    return !!target.querySelector(
      "[data-link-inputs-to-remarks='true'][data-inputs-to-remarks='preview']"
    )
  } else {
    const effectiveTarget = target as HTMLElement

    return effectiveTarget.dataset.inputsToRemarks === 'preview'
  }
}
